// Worker-safe SeriesType enum (no React/TSX dependencies)
export enum SeriesType {
  Temperature = "temperature",
  Humidity = "humidity",
  Co2 = "co2",
  Light = "light",
  Pressure = "pressure",
  Power = "power",
  PowerPerSqm = "powerPerSqm",
  PowerCost = "powerCost",
  PowerCarbon = "powerCarbon",
  AmpHours = "ampHours",
  MaxCurrent = "maxCurrent",
  MinCurrent = "minCurrent",
  Dewpoint = "dewPoint",
  FlowRate = "flowRate",
  NetAccumulator = "netAccumulator",
  NetEnergyAccumulator = "netEnergyAccumulator",
  TemperatureInlet = "temperatureInlet",
  TemperatureOutlet = "temperatureOutlet",
  Sound = "sound",
  SoundMax = "soundMax",
  Tvoc = "tvoc",
  MinTvoc = "minTVOC",
  MaxTvoc = "maxTVOC",
  Pm1 = "pm1",
  Pm2_5 = "pm2_5",
  Pm10 = "pm10",
  Occupied = "occupied",
  Water = "waterUsage",
  Gas = "gasUsage",
  GasCost = "gasCost",
  AverageCurrent = "averageCurrent",
  PowerFactor = "powerFactor",
  ReferenceVoltage = "referenceVoltage",
  Voltage = "voltage",
  MouldRisk = "mouldRisk",
  HealthScore = "healthScore",
  OccupancyPeopleCount = "occupancyPeopleCount",
  OccupancyRegionPeopleCount = "occupancyRegionPeopleCount",
  DwellTimeMax = "dwellTimeMax",
  DwellTimeMean = "dwellTimeMean",
  OccupancyTotalIn = "totalIn",
  OccupancyTotalOut = "totalOut",
  FootTraffic = "footTraffic",
  OccupancyEntryCount = "occupiedEntryCount",
  PositiveAccumulator = "positiveAccumulator",
  PositiveEnergyAccumulator = "positiveEnergyAccumulator",
  NegativeEnergyAccumulator = "negativeEnergyAccumulator",
  GeneratedEnergy = "generatedEnergy",
  ImportedEnergy = "importedEnergy",
  ExportedEnergy = "exportedEnergy",
  OccupiedPercentage = "occupiedPercentage",
  RegionOccupancy = "regionOccupancy",
  TotalWaterVolume = "totalWaterVolume",
  WaterTemperature = "waterTemperature",
  AmbientTemperature = "ambientTemperature",
}
